
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import StatusIcon from '@/components/room/users/StatusIcon.vue';
import { UserRoomStateData, User, MessageHistory } from '@/utils/models';
import { JitsiParticipant, TrackAndElement, UserParticipant } from '@/service/JitsiLibWrapper';
import UserScheduleDisplayer from './UserScheduleDisplayer.vue';
import MessageDisplayer from '@/components/room/users/MessageDisplayer.vue';

@Component({ components: { StatusIcon, UserScheduleDisplayer, MessageDisplayer } })
export default class UserIcon extends Vue {
  @Prop() isLocal!: boolean;
  @Prop() userData!: UserRoomStateData;
  @Prop() scale!: number;
  @Prop() isConnecting!: boolean;
  @Prop() isPictureInPicture!: boolean;
  @Prop() isSharingScreen!: boolean;
  @Emit()
  onRemoveMessage() {}
  @Emit()
  private unmuteAudio() {}
  @Emit()
  remoteVideoMute(): UserRoomStateData {
    return this.userData;
  }
  @Emit()
  requestSchedule(userId: string) {}
  @Emit()
  requestShowSchedule(userData?: UserRoomStateData) {}
  @Emit()
  toggleShowStatusSelector() {}

  onUnmuteAudio() {
    if (this.isLocal) {
      this.unmuteAudio();
    }
  }
  get isDebugMode(): boolean {
    return this.$store.state.isDebugMode;
  }
  get user(): User {
    return this.userData.userState.user;
  }
  get isMyself(): boolean {
    return this.$store.state.user.id === this.user.id;
  }
  get userInitial(): string {
    return this.user.name.slice(0, 1);
  }
  get isFocus(): boolean {
    return this.userData.userState.isFocus;
  }
  get userMessage(): string {
    return this.userData.userState.userMessage;
  }
  get status(): string {
    return this.userData.userState.status;
  }
  get isMoving(): boolean {
    return this.$store.state.isMoving;
  }
  get hasRoomVolume(): boolean {
    return this.userData.roomVolume >= 0;
  }
  get audioMutedRemotely(): boolean {
    return this.userData.userParticipant?.audioTrack?.track.isMuted() ?? false;
  }
  get videoMuted(): boolean {
    return this.userData.userState.videoMuted;
  }
  get audioMuted(): boolean {
    return this.userData.userState.audioMuted;
  }
  isVideoAvailable: boolean = false;
  get avatarBase64(): string {
    return this.user?.avatarBase64 ?? '';
  }
  get avatarShape(): 'circle' | 'rectangle' {
    return this.user?.avatarShape ?? 'circle';
  }
  private pulseTime: any = 0;
  isShowPulse: boolean = false;
  currentVideoEl: TrackAndElement | null = null;
  private lastRequestDate = 0;
  get name(): string {
    return this.user.name;
  }
  get displayName(): string {
    return this.user.displayName ?? this.user.name;
  }
  get availableAreaStyle(): any {
    const voiceArea = this.userData?.userState?.voiceArea ?? 900;
    const diameter = voiceArea * 2;
    return {
      top: `calc((-${diameter}px + 100%) / 2)`,
      left: `calc((-${diameter}px + 100%) / 2)`,
      width: `${diameter}px`,
      height: `${diameter}px`,
    };
  }
  get voiceAreaColor(): string {
    return this.user.voiceAreaColor ?? '';
  }

  mounted() {
    if (!this.isPictureInPicture) {
      this.userData.on('tracksUpdate', this.onTracksUpdate);
      this.userData.on('participantChanged', this.onParticipantChanged);
    }
    this.userData.on('audioLevelChanged', this.updateAudioLevel);
  }
  beforeDestroy() {
    this.userData.off('tracksUpdate', this.onTracksUpdate);
    this.userData.off('audioLevelChanged', this.updateAudioLevel);
    this.userData.off('participantChanged', this.onParticipantChanged);
  }
  onTracksUpdate(ev: TrackAndElement | number | undefined | JitsiParticipant) {
    if (typeof ev === 'number' || typeof ev === 'undefined' || !this.userData.userParticipant) {
      return;
    }
    let videoTrackEl = this.userData.userParticipant.tracks.find(
      (t) => t.track.getType() === 'video' && t.track.videoType !== 'desktop',
    );
    if (videoTrackEl === ev) {
      // 追加の時
      const videoWrapper = this.$refs.videoWrapper as HTMLDivElement;
      if (videoWrapper) {
        if (videoWrapper.hasChildNodes()) {
          videoWrapper.childNodes.forEach((n) => videoWrapper.removeChild(n));
        }
        videoWrapper.appendChild(videoTrackEl.el);
      }
      this.currentVideoEl = ev;
      if (videoTrackEl.el.paused) {
        videoTrackEl.el.play();
      }
      this.isVideoAvailable = true;
    } else if ((ev as TrackAndElement).track?.getType() === 'video') {
      // video 削除の時
      if (this.currentVideoEl) {
        this.currentVideoEl.el.remove();
      }
      this.currentVideoEl = null;
      this.isVideoAvailable = false;
    }
  }
  onParticipantChanged(ev: TrackAndElement | number | undefined | JitsiParticipant) {
    if (!ev && this.currentVideoEl) {
      this.currentVideoEl.el.remove();
      this.isVideoAvailable = false;
    }
  }

  updateAudioLevel(audioLevel: TrackAndElement | number | undefined | JitsiParticipant) {
    // 閾値をどこかで指定する
    if (typeof audioLevel === 'number' && audioLevel > 0.1) {
      this.isShowPulse = true;
      clearTimeout(this.pulseTime);
      this.pulseTime = setTimeout(() => {
        this.isShowPulse = false;
      }, 1000);
    }
  }
  onHoverSchedule() {
    // 3分以上たってないとリクエストさせない
    if (this.user.authType === 'aad' && this.user.email && this.lastRequestDate < Date.now() - 3 * 60 * 1000) {
      this.requestSchedule(this.user.id);
      this.lastRequestDate = Date.now();
    }
    this.requestShowSchedule(this.userData);
  }

  hasHovered: boolean = false;
  makeNameStandOut() {
    this.hasHovered = true;
  }
  makeNameNormal() {
    this.hasHovered = false;
  }
}
